module.exports = __webpack_public_path__ + "img/封面.90a610e3.png";